export default __webpack_public_path__ + "guard_off-2749bc.mp3";